import React from 'react';
import { MemoryRouter } from 'react-router-dom';

export const wrapper = ({ children }) => (
  <MemoryRouter path="/">{children}</MemoryRouter>
);
